import { useTranslation } from 'react-i18next'

interface Props {
  text: string
  ns?: string
}

const Translations = ({ text, ns }: Props) => {
  const { t } = useTranslation(ns)

  return <>{t(text)}</>
}

export default Translations
